













import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * 板块通用样式
 */
@Component
export default class CustomPageSection extends Vue {
  @Prop({ type: String }) title: string;

  get hasTitle() {
    return !!this.title || !!this.$slots.title;
  }
}
